<template>
  <Insights
    module-class="interactive-map"
    :roleIdProp="roleIdProp"
    :citiesString="citiesString"
    insights-api-url="/api/interactive-map/insights"
    prompts-api-url="/api/interactive-map/prompts"
  />
</template>

<script>
import Insights from '@/Shared/Insights/Insights.vue'

export default {
  name: 'InteractiveMapInsights',
  components: {
    Insights
  },
  props: {
    roleIdProp: {
      type: Number,
      required: true
    },
    citiesString: {
      type: String,
      default: ''
    }
  },
  methods: {
    // Métodos específicos para o mapa interativo, se necessário
  }
}
</script>

<style scoped>
/* Estilos específicos para os Insights do mapa interativo, se necessário */
</style> 